import ModalDelete from 'components/ModalDelete'
import * as React from 'react'
import { I18n } from 'react-redux-i18n'
import { useDispatch, useSelector } from 'react-redux'

import { addNewDelegation, updateDelegation } from '../../../redux/actions/delegations'
import ModalWrapper from '../../ChannelView/ModalWrapper'
import dkvConfiguration from 'constants/dkv.constants'
import { lang } from 'utils/helpers'

const body = (props) => (
  <div className='modal-brand'>
    <div className='input-label mt-3'>{lang('dashboard_delegation-name')}</div>
    <input className='name-input' defaultValue={props.delegationName} onChange={(e) => props.setDelegationName(e.target.value)} />
    {
      dkvConfiguration.isDKV &&
      <>
        <div className='input-label mt-3'>{I18n.t('dashboard_origin')}</div>
        <input className='name-input' type='number' defaultValue={props.dkvOrigin} onChange={(e) => props.setDkvOrigin(e.target.value)} />
      </>
    }
    <div className='buttons-container'>
      <div className='save-button' onClick={props.mainAction}>{props.currentDelegation._id ? lang('dashboard_save') : lang('dashboard_add')}</div>
      <div className='cancel-button' onClick={props.toggle}>{lang('dashboard_cancel')}</div>
    </div>
  </div>
)

const ModalDelegation = (props) => {
  const {
    isOpen, currentDelegation = {}, currentBrand = {},
    toggle, getCompany, removeDelegation
  } = props

  const [ isSubmitting, setIsSubmitting ] = React.useState(false)
  const [delegationName, setDelegationName] = React.useState(currentDelegation.name)
  const [dkvOrigin, setDkvOrigin] = React.useState(currentDelegation.dkvOrigin || '')

  const dispatch = useDispatch()
  const companies = useSelector(state => state.companies)

  const saveDelegation = () => {
    if (isSubmitting) return null
    setIsSubmitting(true)
    const dataDelegation = dkvConfiguration.isDKV
      ? { ...currentDelegation, name: delegationName, dkvOrigin }
      : { ...currentDelegation, name: delegationName }

    dispatch(updateDelegation(dataDelegation))
      .then(() => {
        toggle()
        getCompany()
        setIsSubmitting(false)
      })
      .catch(() => {
        setIsSubmitting(false)
      })
  }

  const addDelegation = () => {
    if (isSubmitting) return null
    setIsSubmitting(true)
    const dataDelegation = dkvConfiguration.isDKV
      ? { name: delegationName, brand: currentBrand._id, company: companies._id, dkvOrigin }
      : { name: delegationName, brand: currentBrand._id, company: companies._id }

    dispatch(addNewDelegation(dataDelegation))
      .then(() => {
        toggle()
        getCompany()
        setIsSubmitting(false)
      })
      .catch(() => {
        setIsSubmitting(false)
      })
  }

  return (
    props.currentDelegation.forRemove ?
      <ModalDelete
        isOpen={isOpen}
        toggle={toggle}
        header={I18n.t('company_remove_delegation')}
        text1={I18n.t('company_remove_delegation_title')}
        text2={`${I18n.t('company_remove_delegation_legend')}<br/><strong>${currentDelegation.name}</strong>`}
        event={
          async () => {
            setIsSubmitting(true)
            await removeDelegation(currentDelegation)
            setIsSubmitting(false)
          }
        }
        isSubmitting={isSubmitting}
      />
      :
      <ModalWrapper
        id={'modalDelegation'}
        header={currentDelegation._id ? <h1>{lang('dashboard_edit-delegation')}</h1> : <h1>{lang('dashboard_add-delegation')}</h1>}
        body={
          body({
            ...props,
            mainAction: currentDelegation._id ? saveDelegation : addDelegation,
            delegationName: currentDelegation.name,
            dkvOrigin: currentDelegation.dkvOrigin || '',
            setDelegationName,
            setDkvOrigin
          })
        }
        isOpen={isOpen}
        toggle={toggle}
        showClose={true}
      />
  )
}

export default ModalDelegation